import React, {useCallback, useState} from "react";
import {confirmAlert} from "react-confirm-alert";
import {Switch} from "antd";
import {switchWeekend} from "../../api/members";
import {toast} from "react-toastify";
import {syncWithServer} from "../actions/syncWithServer";

export const useChangeWeekendComponent = (course) => {
    const [weekCheck, setWeekCheck] = useState(course?.data?.weekendOff || false);
    const onWeekChange = useCallback(async (e, course) => {
        await confirmAlert({
            title: "Vahvista poisto",
            message: "Oletko varma.",
            buttons: [
                {
                    label: "Kyllä",
                    onClick: async () => {
                        await switchWeekend({
                            adminId: course.data?.adminId,
                            courseId: course.id,
                        }, ({data, status}) => {
                            if(status){
                                syncWithServer()
                            }else{
                                toast.error("Virhe tapahtui")
                            }
                        });

                    },
                },
                {
                    label: "Ei",
                    onClick: () => {
                    },
                },
            ],
        });
    }, [weekCheck])

    return (
        <Switch
            checked={weekCheck}
            checkedChildren='weekend off'
            unCheckedChildren='weekend on'
            onChange={checked => {
                onWeekChange(checked, course);
            }}
        />
    )
}
